import React, { useState, useEffect } from 'react';
import blsApiService from '../services/blsApiService';

const BlsTest = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const testApi = async () => {
      setLoading(true);
      console.log('Testing BLS API...');
      console.log('API Key:', import.meta.env.VITE_BLS_API_KEY);
      
      try {
        // Test a simple BLS API call
        const testResult = await blsApiService.getPopularSeries();
        console.log('BLS result:', testResult);
        setResult(testResult);
      } catch (error) {
        console.error('BLS API Test Error:', error);
        setResult({ success: false, error: error.message });
      } finally {
        setLoading(false);
      }
    };

    testApi();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>BLS API Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Configuration:</h3>
        <p><strong>API Key:</strong> {import.meta.env.VITE_BLS_API_KEY ? 'Set' : 'Not set'}</p>
        <p><strong>Base URL:</strong> https://api.bls.gov/publicAPI/v2/timeseries/</p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Test Status:</h3>
        {loading && <p>🔄 Testing BLS API...</p>}
        {result && (
          <div style={{ 
            padding: '10px', 
            backgroundColor: result.success ? '#d4edda' : '#f8d7da',
            color: result.success ? '#155724' : '#721c24',
            border: `1px solid ${result.success ? '#c3e6cb' : '#f5c6cb'}`,
            borderRadius: '5px'
          }}>
            <p><strong>Status:</strong> {result.success ? '✅ Success' : '❌ Failed'}</p>
            {result.error && <p><strong>Error:</strong> {result.error}</p>}
            {result.data && <p><strong>Data received:</strong> {JSON.stringify(result.data).substring(0, 200)}...</p>}
          </div>
        )}
      </div>

      <div style={{ 
        padding: '10px', 
        backgroundColor: '#e0e0e0', 
        borderRadius: '5px',
        fontSize: '12px'
      }}>
        <h4>Console Logs:</h4>
        <p>Check the browser console for detailed API request/response logs.</p>
      </div>
    </div>
  );
};

export default BlsTest;
